import { ButtonBaseProps, ButtonVariantType } from './button.types';
import ButtonPrimary from './PrimaryButton';
import ButtonSecondary from './SecondaryButton';

type Props = ButtonBaseProps & {
  variant: ButtonVariantType;
};

function UiButton({ variant, ...rest }: Props) {
  const Button = variant === 'primary' ? ButtonPrimary : ButtonSecondary;

  return <Button {...rest} />;
}

export default UiButton;
